export const DATE_FORMATS = {
  US: "MM/dd/yyyy",
  CA: "yyyy-MM-dd",
  UK: "dd/MM/yyyy",
  DE: "dd.MM.yyyy",
  LV: "dd.MM.yyyy",
  AZ: "dd.MM.yyyy",
  IN: "dd/MM/yyyy",
  RU: "dd.MM.yyyy",
  TR: "dd.MM.yyyy",
  UA: "dd.MM.yyyy",
  SE: "dd.MM.yyyy",
  NO: "dd.MM.yyyy",
  DK: "dd.MM.yyyy",
  FI: "dd.MM.yyyy",
  EE: "dd.MM.yyyy",
  LT: "dd.MM.yyyy",
  PL: "dd.MM.yyyy",
  HR: "dd.MM.yyyy",
};
